/* ==========================================================================
   Mondō London — plate reveal
   Viewport-entry fade + rise with an 80ms stagger inside each plate.
   Respects prefers-reduced-motion. Only runs when plates exist.
   ========================================================================== */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var plates = document.querySelectorAll('.plate, .pl-interleaf, .pl-colophon');
  if (!plates.length || !('IntersectionObserver' in window)) return;

  plates.forEach(function (p) { p.classList.add('will-reveal'); });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var kids = e.target.querySelectorAll('.card, .pl-rule, .folio-head, .folio-viewall, .idx-title, .idx-count, .idx-list, .makers, .crossrefs, .consult, p');
      var i = 0;
      kids.forEach(function (k) {
        if (k.dataset.revealed) return;
        k.dataset.revealed = '1';
        k.style.transitionDelay = (i * 80) + 'ms';
        i++;
      });
      e.target.classList.add('is-revealed');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });

  plates.forEach(function (p) { io.observe(p); });
})();
